import { UseAppFormProps } from "hooks/useAppForm";
import React, { useEffect, useState } from "react";
import { FormValueProps } from ".";
import useAppSelector from "hooks/useAppSelector";
import { apiBookingConfigIndex, BookingConfigItemProps } from "apis/booking";

interface Props {
    form: UseAppFormProps<FormValueProps>
}

export const PageSelectTime: React.FC<Props> = ({ form }) => {
    const timeFrame = useAppSelector(state => state.timeFrame);

    const [bookingConfigs, setBookingConfigs] = useState<BookingConfigItemProps[]>([]);

    useEffect(() => {
        setBookingConfigs([]);
        if (form.values.date) {
            apiBookingConfigIndex({
                fromDate: form.values.date,
                toDate: form.values.date,
                timeFrameIds: timeFrame.list.options.map(item => item.id)
            })
                .then(res => {
                    setBookingConfigs(res.data || []);
                })
        }

    }, [form.values.date, timeFrame.list.options]);

    return (
        <div className="p-4 bg-white rounded shadow">
            <h2 className="text-lg font-bold mb-4">CHỌN GIỜ</h2>
            <div className="grid grid-cols-4 gap-3">
                {timeFrame.list.options.map((t, i) => {
                    const disabled = bookingConfigs.findIndex(b => b.dateSelected === form.values.date && b.timeFrameId === t.id) === -1;
                    return <button
                        disabled={disabled}
                        type="button"
                        key={i}
                        onClick={() => form.handleChange({ timeFrameId: t.id })}
                        className={`p-3 border rounded text-center cursor-pointer ${disabled ? "disabled:bg-gray-100 disabled:cursor-not-allowed" : "hover:border-blue-500"}`}
                    >
                        {t.name}
                    </button>
                })}
            </div>
        </div>
    );
};
